import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '../../auth/auth.guard';
import {ApplicationsComponent} from './pages/applications/applications.component';
import {ApplicationsPatientListComponent} from './pages/applications-patients-list/applications-patients-list.component';
import {ApplicationsPatientProfileComponent} from './pages/applications-patient-profile/applications-patient-profile.component';

const routes: Routes = [
  {
    path: 'applications',
    component: ApplicationsComponent,
    canActivate: [AuthGuard],

    children: [
      {
        path: '',
        redirectTo: 'patients-list',
        pathMatch: 'full'
      },
      {
        path: 'patients-list',
        component: ApplicationsPatientListComponent,
      },
      {
        path: 'patients-list/:id',
        component: ApplicationsPatientProfileComponent,
      }
    ],
  },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class ApplicationsRouterModule {
}
